// extracted by mini-css-extract-plugin
export default {"HTMLDetails":"HTMLDetails_HTMLDetails__lVjl+","title":"HTMLDetails_title__KWLFP","content":"HTMLDetails_content__ON-YX"};